import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import CustomCol from '../../../../../components/CustomCol';
import CustomPickColor from '../../../../../components/CustomPickColor';
import CustomRow from '../../../../../components/CustomRow';
import Input from '../../../../../components/InputNew';
import StyledLink from '../../../../../components/Link';
import Log from '../../../../../components/Log/Log';
import SubAbas from '../../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../../modules/contexts/Auth/RequireAuth';
import { ICorForm, ICorRegistro } from '../../../../../modules/types/Cor';
import { getCorById } from '../../../../../services/cores/corService';
import { formataNomeMeioSiglas } from '../../../../../utils/functions';
import { handleDelete } from '../../../../../utils/handleDelete';
import { handleSave } from '../../../../../utils/handleSave';
import SubAbasCores from '../utils/subabasCores';

export default function CorIdentificacao() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;

  //COMPONENTE
  const params = useParams();
  const fichaID = String(params.id);

  const [logData, setLogData] = useState<ICorRegistro | null>(null);
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);

  //FORMULÁRIO
  const [dataRaw, setDataRaw] = useState<ICorForm | null>(null);
  const [formMain, setFormMain] = useState<ICorForm>({
    id: '',
    usuarioId: userID,
    codigoHexadecimal: '',
    nomeCor: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string | number): Promise<void> => {
    try {
      const registroData: ICorRegistro = await getCorById(String(id));

      setLogData(registroData);

      const formValues: ICorForm = {
        id: registroData.id,
        usuarioId: userID,
        codigoHexadecimal: registroData.codigoHexadecimal,
        nomeCor: registroData.nomeCor,
        observacoes: registroData.observacoes,
      };

      setFormMain(formValues);
      setDataRaw(formValues);
      triggerRefresh();
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    if (fichaID !== 'undefined') {
      fetchData(fichaID);
    }
  }, [fichaID]);

  const subAbas =
    fichaID !== 'undefined'
      ? SubAbasCores(fichaID)
      : [
          {
            label: 'Dados Gerais',
            rota: `/daf/adm/cores/cor/dadosgerais`,
          },
        ];

  const logs = logData
    ? {
        id: logData.id,
        usuarioRegistro: formataNomeMeioSiglas(
          logData.usuarioRegistro.nomeCompleto,
        ),
        usuarioAtualizacao: formataNomeMeioSiglas(
          logData.usuarioAtualizacao.nomeCompleto,
        ),
        dataRegistro: logData.dataRegistro,
        dataAtualizacao: logData.dataUltimaAtualizacao,
        nEdicoes: logData.nEdicoes,
      }
    : null;

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    setFormMain((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const camposObrigatorios = {
    nomeCor: 'Nome da Cor',
    codigoHexadecimal: 'Código Hexadecimal',
  };

  const camposAjustar = {
    number: ['id', 'usuarioId'],
    string: ['observacoes'],
  };

  const salvar = () =>
    handleSave(
      formMain,
      camposObrigatorios,
      camposAjustar,
      'cores',
      'daf/adm/cores/cor',
      fetchData,
      true,
      dataRaw,
    );

  const deletar = () => handleDelete(fichaID, 'cores', 'daf/adm/cores');

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/adm/cores"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        {logs && (
          <Log
            {...logs}
            entity="TB_COR"
            id={Number(formMain.id)}
            refreshTriggerLog={refreshTriggerLog}
          />
        )}
        {/* Identificação do Domínio */}
        <BoxConteudo boxTitulo="Identificação da Cor">
          <CustomRow
            style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
          >
            <CustomCol width="200px">
              <CustomPickColor
                id="codigoHexadecimal"
                name="codigoHexadecimal"
                label="Código Hex"
                value={formMain.codigoHexadecimal}
                onChange={handleChange}
              />
            </CustomCol>

            <CustomCol>
              <Input
                id="nomeCor"
                name="nomeCor"
                value={formMain.nomeCor}
                label="Nome da Cor"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol>
              <Input
                id="observacoes"
                name="observacoes"
                value={formMain.observacoes}
                label="Observações"
                type="textarea"
                onChange={handleChange}
                linhas={3}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={deletar}
            save
            onClickSave={salvar}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={salvar} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
